export default __webpack_public_path__ + "static/media/chill-2x.c8046976.png";